﻿module.exports = [formatDutyFilter];

function formatDutyFilter() {
    var i;
    var preBreakReplacements = [
        ['van de waarde omzetbelasting', '']
    ];

    var postBreakReplacements = [
        [/\$(.)/g, '<sup>$1</sup>'],
        [/@(.)/g, '<sub>$1</sub>']
    ];

    return function (input) {
        if (input === null || input === undefined)
            return input;

        for (i = 0; i < preBreakReplacements.length; i++) {
            input = input.replaceAll(preBreakReplacements[i][0], preBreakReplacements[i][1]);
        }
        
        var breakLength = 30;
        
        if (input.length > breakLength) {
            for (i = 1; i < input.length / breakLength; i++) {
                var breakIndex = input.indexOf(' ', i * breakLength);
                if (breakIndex <= 0)
                    break;
                input = input.substr(0, breakIndex) + '<br/>' + input.substr(breakIndex);
            }
        }

        for (i = 0; i < postBreakReplacements.length; i++) {
            input = input.replaceAll(postBreakReplacements[i][0], postBreakReplacements[i][1]);
        }

        return input;
    };
}